<!-- TEMPLATE CONTRACT: Ui Stock Selector Component owns the visible Angular template structure for src/app/shared/ui/ui-stock-selector/ui-stock-selector.component.html. -->
<div class="ui-stock-selector">
  <ui-select
    [label]="categoryLabel()"
    [value]="value().categoryId"
    [options]="categoryOptions()"
    [placeholder]="categoryPlaceholder()"
    (valueChange)="selectCategory($event)"
  ></ui-select>

  <ui-select
    [label]="productLabel()"
    [value]="value().productId"
    [options]="filteredProducts()"
    [disabled]="!value().categoryId"
    [placeholder]="productPlaceholder()"
    (valueChange)="selectProduct($event)"
  ></ui-select>

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (showVariant()) {
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (allowMultipleVariants()) {
      <ui-select
        [label]="variantLabel()"
        [multiple]="true"
        [closeOnSelect]="false"
        [values]="value().variantIds"
        [options]="filteredVariants()"
        [disabled]="!value().productId"
        [placeholder]="variantPlaceholder()"
        (valuesChange)="selectVariants($event)"
      ></ui-select>
    } @else {
      <ui-select
        [label]="variantLabel()"
        [value]="value().variantId"
        [options]="filteredVariants()"
        [disabled]="!value().productId"
        [placeholder]="variantPlaceholder()"
        (valueChange)="selectVariant($event)"
      ></ui-select>
    }
  }

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (showQuantity()) {
    <ui-form-field
      [label]="quantityLabel()"
      type="number"
      min="1"
      [required]="true"
      [value]="value().quantity === null ? '' : '' + value().quantity"
      [error]="quantityError()"
      (valueChange)="setQuantity($event)"
    ></ui-form-field>
  }
</div>
